// Apolo IDE — PlanApprovalActions (Sprint v4 Epic S2 WS S2.3).
//
// Three buttons rendered under PlanPreview: Approve / Reject / Re-plan.
// State is owned by the parent (useDecomposer hook). The component is
// purely presentational so it can be re-used from a modal, side panel,
// or composer footer without bringing the hook along.

import { Check, X, RefreshCw, Loader2 } from 'lucide-react';

export default function PlanApprovalActions({
  phase,
  busy,
  budgetBlocked,
  onApprove,
  onReject,
  onReplan,
  disableReplan,
}) {
  const isApproving = phase === 'approving';
  const isPlanning = phase === 'planning';
  const isFinal = phase === 'approved' || phase === 'rejected';
  const approveDisabled = busy || budgetBlocked || isFinal;
  const rejectDisabled = busy || isFinal;
  const replanDisabled = busy || isPlanning || disableReplan;

  return (
    <div
      data-testid="plan-approval-actions"
      className="flex items-center justify-end gap-2 border-t border-apolo-borderSubtle pt-3"
    >
      <button
        type="button"
        onClick={onReplan}
        disabled={replanDisabled}
        aria-label="Refazer plano"
        className="inline-flex items-center gap-1 rounded-md border border-apolo-borderSubtle px-2.5 py-1 text-[11px] text-apolo-textSecondary transition hover:bg-apolo-surface2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <RefreshCw size={11} aria-hidden="true" />
        Re-plan
      </button>
      <button
        type="button"
        onClick={onReject}
        disabled={rejectDisabled}
        aria-label="Rejeitar plano"
        data-testid="plan-reject-button"
        className="inline-flex items-center gap-1 rounded-md border border-apolo-borderSubtle px-2.5 py-1 text-[11px] text-apolo-error transition hover:bg-apolo-error/10 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <X size={11} aria-hidden="true" />
        Rejeitar
      </button>
      <button
        type="button"
        onClick={onApprove}
        disabled={approveDisabled}
        aria-label="Aprovar e despachar plano"
        data-testid="plan-approve-button"
        className="inline-flex items-center gap-1 rounded-md bg-apolo-accent px-3 py-1 text-[11px] font-medium text-apolo-bg transition hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {isApproving ? (
          <Loader2 size={11} className="animate-spin" aria-hidden="true" />
        ) : (
          <Check size={11} aria-hidden="true" />
        )}
        {isApproving ? 'Despachando…' : 'Aprovar'}
      </button>
    </div>
  );
}
